import SvgIcon from '@mui/material/SvgIcon';

interface MicCheckSuccessIconProps {
  svg?: {
    width?: number;
    height?: number;
  };
}

export const MicCheckSuccessIcon = ({ svg }: MicCheckSuccessIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={svg?.width || 72}
    height={svg?.height || 72}
    viewBox="0 0 72 72"
    fill="none"
    sx={{
      width: svg?.width || 72,
      height: svg?.height || 72,
    }}
  >
    <path
      d="M35.9999 0.324341C16.3069 0.324341 0.324219 16.307 0.324219 36C0.324219 55.693 16.3069 71.6757 35.9999 71.6757C55.6929 71.6757 71.6756 55.693 71.6756 36C71.6756 16.307 55.6929 0.324341 35.9999 0.324341ZM26.3318 51.3049L13.5242 38.4973C12.1329 37.106 12.1329 34.8584 13.5242 33.467C14.9156 32.0757 17.1631 32.0757 18.5545 33.467L28.8648 43.7416L53.4096 19.1968C54.801 17.8054 57.0485 17.8054 58.4399 19.1968C59.8312 20.5881 59.8312 22.8357 58.4399 24.227L31.3621 51.3049C30.0064 52.6962 27.7231 52.6962 26.3318 51.3049Z"
      fill="#19A940"
    />
  </SvgIcon>
);
